import { useData } from '@app/data/repositories';
import { TaskDetailScreen } from './TaskDetailScreen';
import { useTaskDetail } from './useTaskDetail';

/** Вход карточки задачи. */
export function TaskDetailRoute({
  taskId,
  onBack,
  onOpenCase,
  onOpenClient,
}: {
  taskId: string;
  onBack: () => void;
  onOpenCase: (caseId: string) => void;
  onOpenClient: (clientId: string) => void;
}) {
  const { db } = useData();
  const { state, actions } = useTaskDetail(taskId, db);

  return (
    <TaskDetailScreen
      state={state}
      actions={actions}
      onBack={onBack}
      onOpenCase={onOpenCase}
      onOpenClient={onOpenClient}
    />
  );
}
